module.exports = __webpack_public_path__ + "img/49.a00e606c.jpg";